import { c as _c } from "react/compiler-runtime";
import { Box, Stack, HStack, Avatar, VStack, Image, Heading, Text, AspectRatio } from '@chakra-ui/react';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
type ArticleDetailProps = {
  authors?: string | any[];
  authorSlug?: string;
  avatar?: string;
  featuredImage?: string;
  firstName?: string;
  lastName?: string;
  slug?: string;
  subjectLogos?: string;
  subjectNames?: string;
  title?: string;
  typeSlug?: string;
};
export const ArticleDetailHero = props => {
  const $ = _c(54);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([10, 20]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.featuredImage ? "row" : "column";
  let t2;
  if ($[2] !== getBreakpointValue || $[3] !== props.featuredImage) {
    t2 = props.featuredImage ? getBreakpointValue(["center", "center", "center", "flex-start", "flex-start"]) : "center";
    $[2] = getBreakpointValue;
    $[3] = props.featuredImage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.subjectLogos || $[6] !== props.typeSlug) {
    t3 = props.typeSlug === "founder-interviews" && <>{props.subjectLogos && <Image maxW="8em" objectFit="contain" opacity={0.5} src={props.subjectLogos} />}</>;
    $[5] = props.subjectLogos;
    $[6] = props.typeSlug;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = props.featuredImage ? "container.sm" : "full";
  let t5;
  if ($[8] !== getBreakpointValue) {
    t5 = getBreakpointValue(["3xl", "3xl", "4xl"]);
    $[8] = getBreakpointValue;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== getBreakpointValue || $[11] !== props.featuredImage) {
    t6 = props.featuredImage ? getBreakpointValue(["center", "center", "center", "left", "left"]) : "center";
    $[10] = getBreakpointValue;
    $[11] = props.featuredImage;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = `/${props.typeSlug || "articles"}/${props.slug}`;
  let t8;
  if ($[13] !== props.title || $[14] !== t7) {
    t8 = <NextLink href={t7} prefetch={false}>{props.title}</NextLink>;
    $[13] = props.title;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t6 || $[18] !== t8) {
    t9 = <Heading as="h1" size={t5} textAlign={t6}>{t8}</Heading>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== props.subjectNames || $[21] !== props.typeSlug) {
    t10 = props.typeSlug === "founder-interviews" && <Text fontSize="2xl" fontStyle="italic"><Box as="span" opacity="0.5">{"with"}{" "}</Box><Box as="span" fontWeight="bold">{props.subjectNames}</Box></Text>;
    $[20] = props.subjectNames;
    $[21] = props.typeSlug;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t4 || $[25] !== t9) {
    t11 = <VStack align="flex-start" maxWidth={t4}>{t9}{t10}</VStack>;
    $[23] = t10;
    $[24] = t4;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== props.authorSlug || $[28] !== props.authors.length || $[29] !== props.avatar || $[30] !== props.firstName || $[31] !== props.lastName) {
    t12 = props.authors.length > 0 && <AvatarBox avatarUrl={props.avatar} firstName={props.firstName} lastName={props.lastName} slug={props.authorSlug} />;
    $[27] = props.authorSlug;
    $[28] = props.authors.length;
    $[29] = props.avatar;
    $[30] = props.firstName;
    $[31] = props.lastName;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t2 || $[36] !== t3) {
    t13 = <VStack flex={1} gap={8} align={t2}>{t3}{t11}{t12}</VStack>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t2;
    $[36] = t3;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[38] !== getBreakpointValue || $[39] !== props.featuredImage || $[40] !== props.title) {
    t14 = props.featuredImage && <AspectRatio flex={1} hidden={getBreakpointValue([true, true, true, false])} ratio={1.5555555555555556} width="full"><Image alt={props.title} borderRadius="3xl" boxShadow="sm" objectFit="cover" src={props.featuredImage} w="100%" /></AspectRatio>;
    $[38] = getBreakpointValue;
    $[39] = props.featuredImage;
    $[40] = props.title;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t1 || $[43] !== t13 || $[44] !== t14) {
    t15 = <Stack align="center" direction={t1} gap={20} maxWidth="container.xl" width="full">{t13}{t14}</Stack>;
    $[42] = t1;
    $[43] = t13;
    $[44] = t14;
    $[45] = t15;
  } else {
    t15 = $[45];
  }
  let t16;
  if ($[46] !== t0 || $[47] !== t15) {
    t16 = <Stack align="center" backdropBlur="40px" backdropFilter="auto" bg="linear-gradient(to right, background 10%, backgroundAlpha.500)" direction="row" justify="center" padding={t0} position="relative" width="full" zIndex={2}>{t15}</Stack>;
    $[46] = t0;
    $[47] = t15;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  const t17 = props.featuredImage ? `linear-gradient(180deg, transparent 20%, #1F2128 80%), url(${props.featuredImage}) center center/cover no-repeat` : "linear-gradient(180deg, transparent 20%, #1F2128 80%)";
  let t18;
  if ($[49] !== t17) {
    t18 = <Box height="full" position="absolute" top={0} width="full" zIndex={-1} background={t17} />;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t16 || $[52] !== t18) {
    t19 = <Box position="relative" width="full">{t16}{t18}</Box>;
    $[51] = t16;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  return t19;
};
const AvatarBox = t0 => {
  const $ = _c(17);
  const {
    avatarUrl,
    firstName,
    lastName,
    slug
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const t1 = `/authors/${slug || ""}`;
  let t2;
  if ($[0] !== getBreakpointValue) {
    t2 = getBreakpointValue(["sm", "md"]);
    $[0] = getBreakpointValue;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${firstName} ${lastName}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Avatar.Fallback name={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== avatarUrl) {
    t5 = <Avatar.Image src={avatarUrl} />;
    $[4] = avatarUrl;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t5) {
    t6 = <Avatar.Root size={t2}>{t4}{t5}</Avatar.Root>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== firstName || $[11] !== lastName) {
    t7 = <Text as="span" textStyle="labelLg">{firstName} {lastName}</Text>;
    $[10] = firstName;
    $[11] = lastName;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t1 || $[14] !== t6 || $[15] !== t7) {
    t8 = <HStack asChild={true}><NextLink href={t1}>{t6}{t7}</NextLink></HStack>;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};